import { useQuery } from "@tanstack/react-query";

import { FETCH_ERROR } from "../consts/fetch-error";
import { getOrganization, getOrganizations } from "../services/organization";

export function useGetOrganizations() {
  return useQuery({
    queryKey: ["organizations"],
    queryFn: () => getOrganizations(),
    staleTime: 1000 * 60 * 60, // 1 hour
    retry: (_failureCount, error: unknown) =>
      error !== FETCH_ERROR.UNAUTHORIZED,
  });
}

export function useGetOrganization(id: string) {
  return useQuery({
    queryKey: ["organization", id],
    queryFn: () => getOrganization(id),
    retry: (_failureCount, error: unknown) =>
      error !== FETCH_ERROR.UNAUTHORIZED,
  });
}
